export function PromptComposerSkeleton() {
  return (
    <div className="animate-pulse rounded-[28px] border border-border bg-card p-6">
      <div className="mb-3 h-5 w-2/3 rounded bg-muted" />
      <div className="mb-2 h-4 w-full rounded bg-muted" />
      <div className="h-4 w-5/6 rounded bg-muted" />
    </div>
  );
}